import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@lichtblick/icons/components/Icon';
import { toIconName } from '@lichtblick/icons/utils/icon-name';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import classNames from 'classnames';
import { getColor, photonColorMap } from '../../utils/colors';
import { AButton } from '../AButton';
import styles from './o-info-teaser.module.scss';
export const OInfoteaser = ({ accent, anchorId, button, containerStyle, headline, icon, iconColor: iconShiftColor, text, theme })=>{
    const fullBoxed = containerStyle === 'full-boxed' && accent;
    const iconColor = fullBoxed ? photonColorMap[accent] : photonColorMap[theme];
    return /*#__PURE__*/ _jsx("section", {
        className: classNames(styles.container, styles[`bg-${theme}`]),
        "data-testid": "info-teaser",
        id: anchorId,
        children: /*#__PURE__*/ _jsxs("div", {
            className: classNames(styles.wrapper, fullBoxed && styles[`bg-${accent}`], fullBoxed && styles['wrapper-boxed']),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: classNames(styles.icon, styles[`icon-color-${iconColor}`]),
                    children: icon && /*#__PURE__*/ _jsx(Icon, {
                        name: toIconName(icon),
                        shiftColor: iconShiftColor ? getColor(iconShiftColor) : undefined
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.content,
                    children: [
                        headline && /*#__PURE__*/ _jsx(Headline, {
                            renderAs: "h4",
                            size: "s",
                            children: headline
                        }),
                        text && /*#__PURE__*/ _jsx(Text, {
                            children: text
                        }),
                        button?.length === 1 && /*#__PURE__*/ _jsx(AButton, {
                            ...button[0],
                            variant: "link"
                        })
                    ]
                })
            ]
        })
    });
};

//# sourceMappingURL=OInfoteaser.js.map